/**
 * 手机号图标
 */
const PhoneNumberIcon = ({ color = '#6E6E73' }) => {
  return (
    <svg width="16" height="16" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.75 10.75H5.04412H7.33824H9.25V1.25H2.75V10.75Z" stroke={color} />
      <path d="M4.75 8.25V9.25L5.25 9.25L7.25 9.25V8.25H4.75Z" fill={color} />
    </svg>
  )
}

export default PhoneNumberIcon
